<script lang="ts" setup>
const props = defineProps({
  bordered: {
    default: false,
    type: Boolean,
  },
  dragging: {
    default: false,
    type: Boolean,
  },
  id: {
    required: true,
    type: String,
  },
  opened: {
    default: true,
    type: Boolean,
  },
  title: {
    required: true,
    type: String,
  },
})

const emit = defineEmits<{
  toggle: [ sectionId: string]
}>()

function onToggle() {
  emit('toggle', props.id)
}
</script>

<template>
  <div class="w-full text-left">
    <div
      class="gradient-texture-light group flex cursor-pointer select-none items-center border-gray-200 bg-gray-100 px-4 py-3 text-xs uppercase dark:border-gray-800 dark:bg-gray-900"
      :class="{
        'border-b': opened && !bordered,
        'border-t': !bordered,
        'border': bordered,
        'border-b-0': !opened && bordered,
      }"
      @click="onToggle"
    >
      <UIcon
        class="js-drag-handle size-5.5 mr-1.5 flex-initial cursor-move text-gray-500 group-hover:text-black dark:text-gray-500 dark:group-hover:text-white"
        :name="getIcon('drag')"
      />

      <span class="flex-1">{{ title }}</span>

      <UIcon
        class="size-3.5 flex-initial transform cursor-pointer text-gray-500 group-hover:text-black dark:text-gray-500 dark:group-hover:text-white"
        :class="{ 'rotate-90': !opened }"
        :name="getIcon('caret')"
        @click.stop="onToggle"
      />
    </div>

    <div
      v-if="opened && !dragging"
      class="grid grid-cols-1 gap-5 p-5"
    >
      <slot />
    </div>
  </div>
</template>
